// Assessment Overview section form field enum
export enum AssessmentOverviewFormField {
  APPOINTMENT_TIME = 'assessmentOverview/appointmentTime'
}
